// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ADD_PRODUCTS_BANNER_DESCRIPTION = "Pridaj si do profilu svoj TOP v\u00fdber a in\u0161piruj ostatn\u00fdch.";
export const ADD_PRODUCTS_BANNER_TITLE = "Pom\u00f4\u017e mami\u010dk\u00e1m s v\u00fdberom spr\u00e1vnej v\u00fdbavi\u010dky\n";
